<template>
</template>

<script>
export default {
    mounted ()
        {
        this.$q.dialog({
            title: 'Выход',
            message: 'Вы действительно хотите выйти из Личного кабинета?',
            ok: 'Да',
            cancel: 'Нет'
        }).then(() => {
            this.addToLog('Выход из системы', 'ExitLK: mounted()', 'ExitLK', this.$route.fullPath, ' - ')
            this.$store.commit('unset_token')
            this.$store.commit('unset_stoken')         
            this.$store.commit('unset_bic')                            
            this.$store.commit('unset_acc')                            
            this.$store.commit('unset_corracc')                            
            this.$store.commit('unset_param')
            this.$store.commit('unset_states')      
            this.$store.commit('unset_transitions')                              
            this.$store.commit('unset_doc_types')      
            this.$store.commit('unset_reports')
            this.$router.push('/auth')
            this.$q.notify({
                message:'Вы покинули Личный кабинет! Для входа используйте Авторизацию',
                type: 'positive',
                color: 'green',
                icon: 'thumb_up'
            })

        }).catch(() => {
            this.$router.push('/settings')
        })
    }
}
</script>